import React from 'react';

const MiniCard = ({ title, amount, percentage, setMarginTop, setColorAlternate,IconType }) => {
  const mainColor = setColorAlternate ? '#B39359' : '#192A3A'; 
  const subColor = setColorAlternate ? 'rgba(179,147,89,0.15)' : '#dcdcdc';

  const smallScreen = window.innerWidth < 768;
return (
  <div
    style={{
      width: '165px',
      height: '140px',
      borderRadius: '10px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      padding: '15px',
      backgroundColor: '#fff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      marginTop: setMarginTop ? '10px' : '0px' || (smallScreen ? '10px' : '0px'), // Define specific values for marginTop
      fontFamily: 'Karla, sans-serif',
      fontWeight: '400',
    }}
    className='mini-card'
  >
      <div style={{ display: 'flex',justifyContent:"center",alignItems:"center",backgroundColor:subColor,width:"40px",height:"40px",borderRadius:"50%" }}>
        <IconType style={{ fontSize: '24px', color: mainColor }} />
      </div>
      <div style={{ marginTop: '10px' }}>
        <p style={{ fontSize: '16px', color: mainColor, margin: 0 }}>{title}</p>
        <p style={{ fontSize: '14px', color: mainColor, margin: 0 }}> {amount}</p>
      </div>
      <div
        style={{
          width: '100%',
          height: '5px',
          backgroundColor: subColor, // Light grey background for the slider
          borderRadius: '5px',
          overflow: 'hidden',
          marginTop: '10px',
        }}
      >
        <div
          style={{
            height: '100%',
            backgroundColor: mainColor, // Dark grey color for the filled portion of the slider
            borderRadius: '5px',
            width: `${percentage}%`,
          }}
        ></div>
      </div>
    </div>
  );
};

export default MiniCard;